"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isShowContactUsPostIlEmploeeDiscount = void 0;
var _postIlEmploeeHelper = require("./postIlEmploeeHelper");
var isShowContactUsPostIlEmploeeDiscount = function isShowContactUsPostIlEmploeeDiscount() {
  if ((0, _postIlEmploeeHelper.isPostIlEmpolee)()) {
    return false;
  }
  return true;
};
exports.isShowContactUsPostIlEmploeeDiscount = isShowContactUsPostIlEmploeeDiscount;